module.exports = __webpack_public_path__ + "assets/440dbe933cb0824f91c362d0a44584f0-DSC_0764.jpg";